var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTgEmployer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Media Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.114 9.29128C16.666 8.73928 17.214 7.45128 14.914 9.01528C11.646 11.2703 8.42504 13.3873 8.42504 13.3873C8.09348 13.5372 7.73503 13.6186 7.37124 13.6265C7.00744 13.6344 6.6458 13.5687 6.30804 13.4333C4.92804 13.0193 3.31704 12.4673 3.31704 12.4673C3.31704 12.4673 2.21704 11.7763 4.10004 11.0403C4.10004 11.0403 12.061 7.77328 14.822 6.62228C15.88 6.16228 19.469 4.69028 19.469 4.69028C19.469 4.69028 21.126 4.04528 20.988 5.61028C20.942 6.25428 20.574 8.51028 20.206 10.9483C19.653 14.3993 19.055 18.1733 19.055 18.1733C19.055 18.1733 18.963 19.2313 18.181 19.4153C17.3439 19.4011 16.5351 19.1099 15.881 18.5873C15.697 18.4493 12.43 16.3783 11.233 15.3663C11.1113 15.2838 11.0124 15.1719 10.9455 15.0409C10.8786 14.9099 10.8459 14.7641 10.8505 14.6171C10.8551 14.4701 10.8968 14.3267 10.9717 14.2001C11.0467 14.0736 11.1524 13.968 11.279 13.8933C12.939 12.3753 14.918 10.4883 16.114 9.29128Z",
    fill: "#58607C"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTgEmployer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tgEmployer.dc179441706a1f4d35f1de3daeb641a8.svg";